import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
  LabelList, 
} from "recharts";
import { IntervalDataItem } from "../../API/dashboardDetailsService";

interface UnidadeGraficoProps {
  titulo: string;
  dados: IntervalDataItem[];
  tipo?: string;
}

const corAzul = "#29306A";

export default function UnidadeGrafico({ titulo, dados }: UnidadeGraficoProps) {
  const total = dados.reduce((acc, item) => acc + item.quantidade, 0);

  const renderTick = (props: any) => {
    const { x, y, payload } = props;
    const maxCharsPerLine = 12;
    const words = String(payload.value).split(" ");
    let lines: string[] = [];
    let currentLine = "";

    words.forEach((word) => {
      if ((currentLine + " " + word).trim().length <= maxCharsPerLine) {
        currentLine = (currentLine + " " + word).trim();
      } else {
        lines.push(currentLine);
        currentLine = word;
      }
    });
    lines.push(currentLine);

    return (
      <text x={x} y={y} textAnchor="end" dominantBaseline="middle" fontSize={15} fill="#4b5563">
        {lines.map((line, index) => (
          <tspan key={index} x={x} dy={index === 0 ? 0 : 12}>{line}</tspan>
        ))}
      </text>
    );
  };

  return (
    <div className="card-grafico-unidades info-card" style={{ flex: 1, backgroundColor: "#f3f3f3ff" }}>
      <h4>{titulo}</h4>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart layout="vertical" data={dados} margin={{ top: 10, right: 35, left: 30, bottom: 10 }}>
          <CartesianGrid stroke="none" />
          <XAxis type="number" />
          <YAxis dataKey="intervalo" type="category" tick={renderTick} />
          <Tooltip
            formatter={(value: any) =>
              typeof value === "number" && total > 0
                ? `${value} (${((value / total) * 100).toFixed(1)}%)`
                : String(value ?? "")
            }
            labelFormatter={(label) => String(label)}
          />
          <Bar dataKey="quantidade" name="Quantidade" fill={corAzul}>
            {dados.map((_, index) => <Cell key={index} fill={corAzul} />)}
            <LabelList dataKey="quantidade" position="right" style={{ fontSize: 10, fill: corAzul, fontWeight: "bold" }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
